module.exports = __webpack_public_path__ + "img/2_15_1.f4260258.jpg";